"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var country_code_to_dialing_code_1 = __importDefault(require("./data/country-code-to-dialing-code"));
var dialing_code_to_country_code_1 = __importDefault(require("./data/dialing-code-to-country-code"));
exports.getPotentialCountryCodeDigits = function (phoneNumber) {
    return phoneNumber.charAt(0) === "+" ? phoneNumber.slice(1, 7) : phoneNumber.slice(0, 6);
};
exports.findCountryCode = function (phoneNumber) {
    if (dialing_code_to_country_code_1.default[phoneNumber.charAt(0)]) {
        return dialing_code_to_country_code_1.default[phoneNumber.charAt(0)];
    }
    if (dialing_code_to_country_code_1.default[phoneNumber.substring(0, 2)]) {
        return dialing_code_to_country_code_1.default[phoneNumber.substring(0, 2)];
    }
    if (dialing_code_to_country_code_1.default[phoneNumber.substring(0, 3)]) {
        return dialing_code_to_country_code_1.default[phoneNumber.substring(0, 3)];
    }
    return null;
};
exports.default = (function (phoneNumber) {
    var potentialCountryCodeDigits = exports.getPotentialCountryCodeDigits(phoneNumber);
    var countryCode = exports.findCountryCode(potentialCountryCodeDigits);
    if (countryCode === null) {
        return null;
    }
    return {
        countryCode: countryCode,
        dialingCode: country_code_to_dialing_code_1.default[countryCode],
    };
});
//# sourceMappingURL=detect-country.js.map